<div class="row">
    <div class="col col-12">
        <app-header />
    </div>
</div>

<div tuiCardLarge tuiSurface="elevated">
    <div class="row">
        <div class="col col-12">
            <div class="row">
                <div class="col col-12">
                    <div tuiHeader class="header-flex">
                        <h1>Le portail médecin est en mode maintenance</h1>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-12">
                    <div class="row">
                        <div class="col col-12">
                            @for (messageMaintenance of messageMaintenanceList0(); track $index) {
                            <app-message-maintenance-card [messageMaintenance]="messageMaintenance" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>